export const debounceFunction = (
  callback: (...args: any) => void,
  delay: number,
) => {
  let timer: any;
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), delay);
  };
};
